import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import global from "./modules/global";
import restaurant from "./modules/restaurant";
import auth from "./modules/auth";
import localization from "./modules/localization";
import chat from "./modules/chat";
import order, {getInitialState as getInitialOrderState} from "./modules/order";

Vue.use(Vuex);

const getPersistedStateKey = () => {
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        return `kuokko-be-v2:${window.location.hostname}`;
    }

    return 'kuokko-be-v2';
};

const sanitizePersistedState = (persistedState) => {
    if (!persistedState || typeof persistedState !== 'object') {
        return persistedState;
    }

    const sanitizedState = {...persistedState};

    if (!sanitizedState.order || typeof sanitizedState.order !== 'object' || Array.isArray(sanitizedState.order)) {
        sanitizedState.order = getInitialOrderState();
    } else {
        sanitizedState.order = Object.assign(getInitialOrderState(), sanitizedState.order);
    }

    return sanitizedState;
};

const store = new Vuex.Store({
    modules: {
        global,
        restaurant,
        auth,
        localization,
        chat,
        order
    },
    plugins: [createPersistedState({
        key: getPersistedStateKey(),
        getState: (key, storage) => {
            const savedValue = storage.getItem(key);
            if (!savedValue) {
                return undefined;
            }

            try {
                return sanitizePersistedState(JSON.parse(savedValue));
            } catch (e) {
                storage.removeItem(key);
                return undefined;
            }
        },
        paths: [
            'localization',
            'auth',
            'order',
            'restaurant'
        ]
    })]
});

export default store;
